/**
 * Multi-script letter mosaic icon for "Language Tools".
 * Renders A (Latin) + अ (Devanagari) + অ (Bengali) — visually
 * conveys "languages mixing".
 */
export default function LanguageIcon({ size = 32, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <text
        x="2"
        y="14"
        fontFamily="'Fredoka', system-ui, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#0284c7"
      >A</text>
      <text
        x="14"
        y="14"
        fontFamily="'Noto Sans Devanagari', system-ui, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#db2777"
      >अ</text>
      <text
        x="24"
        y="14"
        fontFamily="'Noto Sans Bengali', system-ui, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#16a34a"
      >অ</text>
      <text
        x="2"
        y="29"
        fontFamily="'Noto Sans Tamil', system-ui, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#d97706"
      >அ</text>
      <text
        x="14"
        y="29"
        fontFamily="'Noto Sans Telugu', system-ui, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#7c3aed"
      >అ</text>
      <text
        x="24"
        y="29"
        fontFamily="'Noto Sans Gurmukhi', system-ui, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#0891b2"
      >ਅ</text>
    </svg>
  );
}
